<ng-container>
  <!-- Special Case for Form Version V1 => has its own submit button -->
  <!-- TODO: Remove this when V1 is no longer supported -->
  <app-default-card *ngIf="gridRegistration && gridRegistration.formVersion !== 'v1'">
    <h2>Rückfrage zu Ihrer Netzanmeldung</h2>
    <p>{{ latestComment }}</p>
  </app-default-card>

  <ng-template appGridRegistrationForm></ng-template>

  <!-- Special Case for Form Version V1 => has its own submit button -->
  <!-- TODO: Remove this when V1 is no longer supported -->
  <app-default-card
    *ngIf="gridRegistration && gridRegistration.formVersion !== 'v1'"
    fxLayout="column"
    fxLayoutAlign="end">
    <button mat-raised-button color="primary" (click)="submit()">Daten Absenden</button>
  </app-default-card>
</ng-container>
